import { ChangeDetectorRef, Component, OnDestroy, OnInit, HostListener } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ShareService } from "../shared/service/share.service";
import {
  FormGroup,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { LoaderService } from "../shared/loader/loader.service";
import { messages } from "../shared/model/Responsemessages";
import { environment } from "../../../src/environments/environment";
import { RedirectService } from "../Service/redirect.service";
import { TranslateService } from "@ngx-translate/core";
import { TranslationService } from "../common-layout/service/translation.service";
import { MatDialog } from "@angular/material/dialog";
import { CommonComponentComponent } from "../shared/common-component/common-component.component";
import { DeviceDetectorService } from "ngx-device-detector";
import { first } from "rxjs";
import { Capacitor } from "@capacitor/core";
import { AuthService } from "../core/auth/auth.service";
import { Preferences } from '@capacitor/preferences';
import { LocationService } from "../common-layout/layout/header/location/location.service";
import { AppointmentToastrService } from "../shared/appointment-toastr/appointment-toastr.service";
import { FeatureAccessService } from "../shared/service/feature-access.service";
import { SessionOutService } from "../session-out/session-out.service";
import { CommonComponentService } from "../shared/common-component/common-component.service";
import { WebsocketService } from "../shared/service/websocket.service";
import { MenuHorizontalService } from "../common-layout/service/menu-horizontal.service";
import { StorageService } from "../Service/storage.service";
import { PatientSelectionComponent } from "../patient-selection/patient-selection.component";
import { LoginResponseHandlerService } from "../Service/login-response-handler.service";
@Component({
  selector: "kt-otp-verification",
  templateUrl: "./otp-verification.component.html",
  styleUrls: ["./otp-verification.component.scss"],
  standalone: false
})
export class OtpVerificationComponent implements OnInit, OnDestroy {
  currentApplicationVersion = environment.appVersion;
  today: number = Date.now();
  TempData: any;
  OtpVerificationForm: FormGroup;
  Domain: string;
  ipAddress: string;
  domain = window.location.host;
  languageChangeSubscription: any;
  loadingSubmit: boolean = false;
  loadingResend: boolean = false;
  email: string = '';
  resendTimer: number = 0;
  isResendDisabled: boolean = false;
  timerInterval: any;
  expiryTimerInterval: any;
  otpExpired: boolean = false;
  allowExit: boolean = false;
  isTwoFactorAuth: boolean;
  redirectMenu: string = "Dashboard";
  isShowUpgradePopup: any;
  otpExpiryTime: number = 5 * 60; // 5 minutes in seconds
  navigationState: any;
  constructor(
    private readonly fb: FormBuilder,
    private readonly activeRoute: ActivatedRoute,
    public shared: ShareService,
    public LoaderService: LoaderService,
    public route: Router,
    private readonly redirect: RedirectService,
    private readonly translate: TranslateService,
    private readonly translationService: TranslationService,
    private readonly cd: ChangeDetectorRef,
    private readonly storageService: StorageService,
    private readonly dialog: MatDialog,
    public deviceDetectorService: DeviceDetectorService,
    private readonly authService: AuthService,
    public locationservice: LocationService,
    private readonly toastrService: AppointmentToastrService,
    public featureAccessService: FeatureAccessService,
    public sessionTimer: SessionOutService,
    public wsService: WebsocketService,
    public commonComponentService: CommonComponentService,
    private readonly menuHorService: MenuHorizontalService,
    private readonly loginResponseHandlerService: LoginResponseHandlerService
  ) {
    const lang = this.storageService.getItem('language') ?? 'en';
    this.translate.use(lang);
    this.languageChangeSubscription = this.translationService.languageChange.subscribe(
      (newLanguage) => {
        this.translate.use(newLanguage);
        this.cd.detectChanges();
      }
    );
  }

  ngOnInit() {
    if (!this.storageService.getItem("IA")) {
      this.redirect.getIPAddress().subscribe((x: any) => {
        const ipAddress = x.ip;
        this.ipAddress = ipAddress;
        this.storageService.setItem("IA", this.ipAddress);
      });
    }
    this.initOtpVerificationForm();
    this.activeRoute.paramMap.subscribe(() => {
      let data = window.history.state["Data"];
      this.TempData = data;
      if (data?.Email) {
        this.email = data.Email;
        this.storageService.setItem("email", data.Email);
      } else {
        this.email = this.storageService.getItem("email") ?? '';
      }

      if (data == null || data == undefined) {
        this.isResendDisabled = false;
      }
    });
    this.isTwoFactorAuth = Boolean(this.storageService.getItem("TwoFactorAuth"));
    this.navigationState = window.history.state;
    if (this.navigationState && this.navigationState.navigationId != 1) {
      this.storageService.removeItem('resendTimer');
      this.storageService.removeItem('otpExpiryTime');
    }
    this.setOtpExpiryTime();
    this.startResendTimer();
  }
  ngOnDestroy(): void {
    this.languageChangeSubscription.unsubscribe();
    this.storageService.removeItem('resendTimer');
    this.storageService.removeItem('otpExpiryTime');
  }
  initOtpVerificationForm() {
    this.OtpVerificationForm = this.fb.group({
      Code: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(6),
        ]),
      ],
    });
  }

  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds
      .toString()
      .padStart(2, '0')}`;
  }

  @HostListener("window:popstate", ["$event"])
  onPopState(event) {
    event.preventDefault();
    this.route.navigate(["ForgetPasswordEmailVerification"], {
      state: this.TempData,
    });
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.OtpVerificationForm.controls[controlName];
    if (!control) {
      return false;
    }
    const result =
      control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  submit(form: any) {
    if (this.otpExpired) {
      this.shared.showToast("OTP has expired. Please resend OTP.", "Error");
      return;
    }
    this.allowExit = true;

    // Check if it's Registration scenario
    if (this.navigationState?.isRegistration) {
      this.verifyRegistrationOtp(form.value.Code);
      return;
    }

    // Check if it's OTP Login scenario
    if (this.storageService.getItem("isOtpLogin") === "true") {
      this.loginWithOtp(form.value.Code);
      return;
    }

    let data = {
      Email: this.email,
      Domain: this.domain,
      code: form.value.Code,
      isTwoFactorAuth: this.isTwoFactorAuth
    };
    this.loadingSubmit = true;
    this.shared.OTPVerification(data).subscribe((response) => {
      if (response["ResponseCode"] === 483) {
        this.shared.showToast(messages[response["ResponseCode"]], "Success");

        if (this.isTwoFactorAuth) {
          this.login();
        }
        else {
          let data = response;
          this.route.navigate(["forgot"], {
            state: { data },
          });
          this.storageService.removeItem("email");
          this.storageService.removeItem("passwordHash");
        }
      } else if (response["ResponseCode"] === 503) {
        this.shared.showToast(messages[response["ResponseCode"]], "Error");
        this.route.navigate(["/"])
      } else {
        this.shared.showToast(messages[response["ResponseCode"]], "Error");
      }
      this.loadingSubmit = false;
    });
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  resendOTP() {
    if (this.isResendDisabled) return;

    this.loadingResend = true;
    this.LoaderService.show();

    if (this.navigationState?.isRegistration) {
      this.sendRegistrationOtp();
      return;
    }

    const data = {
      Email: this.email,
      Domain: this.domain,
      IsTwoFactorAuth: this.isTwoFactorAuth
    };
    this.shared.ForgetpasswordEmailVerification(data).subscribe({
      next: (response: any) => {
        if (response["Success"]) {
          this.shared.showToast(messages[response["ResponseCode"]], "Success");
          this.startResendTimer(true);
          this.setOtpExpiryTime(true);
        } else {
          this.shared.showToast(messages[response["ResponseCode"]], "Error");
        }
        this.loadingResend = false;
        this.LoaderService.hide();
      },
      error: () => {
        this.shared.showToast("Something went wrong while resending OTP", "Error");
        this.loadingResend = false;
        this.LoaderService.hide();
      }
    });
  }

  startResendTimer(isResend: boolean = false) {
    let storedTimer = Number.parseInt(this.storageService.getItem('resendTimer'));
    if (storedTimer && !Number.isNaN(storedTimer) && storedTimer > 0 && !isResend) {
      this.resendTimer = storedTimer;
    } else if (isResend || (this.navigationState && this.navigationState.navigationId != 1)) {
      this.resendTimer = 90;
      this.storageService.setItem('resendTimer', this.resendTimer.toString());
    }
    else
      return;

    this.isResendDisabled = true;
    this.otpExpired = false;

    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }

    this.timerInterval = setInterval(() => {
      this.resendTimer--;
      if (this.resendTimer <= 0) {
        this.isResendDisabled = false;
        clearInterval(this.timerInterval);
        this.storageService.removeItem('resendTimer');
      }
      this.storageService.setItem('resendTimer', this.resendTimer.toString());
    }, 1000);
  }

  setOtpExpiryTime(isResend: boolean = false) {
    let storedExpiryTimer = Number.parseInt(this.storageService.getItem('otpExpiryTime'));
    if (storedExpiryTimer && !Number.isNaN(storedExpiryTimer) && storedExpiryTimer > 0 && !isResend) {
      this.otpExpiryTime = storedExpiryTimer;
    }
    else if (isResend) {
      this.otpExpiryTime = 300;
      this.storageService.setItem('otpExpiryTime', this.otpExpiryTime.toString());
    }

    if (this.expiryTimerInterval) {
      clearInterval(this.expiryTimerInterval);
    }

    this.expiryTimerInterval = setInterval(() => {
      this.otpExpiryTime--;
      if (this.otpExpiryTime <= 0) {
        this.isResendDisabled = false;
        clearInterval(this.expiryTimerInterval);
        this.otpExpired = true;
        this.storageService.removeItem('otpExpiryTime');
      }
      this.storageService.setItem('otpExpiryTime', this.otpExpiryTime.toString());
    }, 1000);
  }

  canExitResetPage(): boolean {
    if (location.href.includes('/login') || location.href.includes('/Login')) {
      return true;
    }
    return this.allowExit;
  }

  otpControls = Array(6).fill(0);
  otpValues: string[] = ["", "", "", "", "", ""];

  onInput(event: any, index: number) {
    const input = event.target as HTMLInputElement;
    const value = input.value.replace(/\D/g, ''); // only numbers

    if (value) {
      this.otpValues[index] = value;
      if (index < 5) {
        const nextInput = document.getElementById('otp-' + (index + 1)) as HTMLInputElement;
        nextInput?.focus();
      }
    } else {
      input.value = '';
      this.otpValues[index] = '';
    }

    this.OtpVerificationForm.patchValue({ Code: this.otpValues.join('') });
  }

  onKeyDown(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;
    if (event.key === 'Backspace' && !input.value && index > 0) {
      const prevInput = document.getElementById('otp-' + (index - 1)) as HTMLInputElement;
      prevInput?.focus();
    }
  }

  onPaste(event: ClipboardEvent): void {
    const pasteData = event.clipboardData?.getData('text')?.trim() ?? '';
    const inputs = document.querySelectorAll<HTMLInputElement>('.otp-input');

    // Allow paste of 1–6 digits
    if (pasteData && /^\d{1,6}$/.test(pasteData)) {
      pasteData.split('').forEach((char, i) => {
        if (inputs[i]) {
          inputs[i].value = char;
          this.otpValues[i] = char;
        }
      });

      // Focus next empty box (or last one if all filled)
      const nextIndex = Math.min(pasteData.length, inputs.length - 1);
      inputs[nextIndex].focus();

      this.OtpVerificationForm.patchValue({ Code: this.otpValues.join('') });

      // Auto-submit if all 6 digits are filled
      if (pasteData.length === 6) {
        setTimeout(() => this.submit(this.OtpVerificationForm), 200); // slight delay for form sync
      }
    }

    event.preventDefault();
  }

  async login() {
    let password = this.storageService.getItem("passwordHash");
    let ipLocation = this.storageService.getItem("IL") ?? '';
    let ipAddress = this.storageService.getItem("IA") ?? '';
    let isRememberMe = this.storageService.getItem("isRememberMe") === 'true';
    const deviceInfo = this.deviceDetectorService.getDeviceInfo();
    let deviceType = this.getLoginDeviceType(deviceInfo.deviceType);

    const userModel: any = {
      Email: this.email,
      Password: password,
      ipLocation: ipLocation,
      ipAddress: ipAddress,
      deviceType: deviceType,
      Domain: this.domain,
      IsTwoFactorAuthenticated: true
    };

    this.storageService.setItem("MobileDomain", userModel.Domain);

    this.LoaderService.show();
    this.loadingSubmit = true;

    this.authService.signinUser(userModel).pipe(first()).subscribe({
      next: (response) => {
        (async () => {
          this.resetCredentialAfterLogin();
          if (response["Success"] === true &&
            response["Data"] != null &&
            response["AccessToken"] != null &&
            response["Data"]["IsOnboarded"] === true) {
            this.shared.setOnboardUserStorage(response);
            this.LoaderService.hide();
            this.menuHorService.setPath("Dashboard");
            this.route.navigate(["/Dashboard"]);
            return;
          }

          const errorResponseCodes = [543, 105, 499, 531];

          if (response["Success"] === true && (response["Data"] != null || response["UsersList"].length == 1)) {
            // Remember Me storage
            if (Capacitor.isNativePlatform() && isRememberMe) {
              await Preferences.set({
                key: 'loginInfo',
                value: JSON.stringify({
                  domain: this.domain,
                  username: this.email,
                  password: password
                })
              });
            } else {
              await Preferences.remove({ key: 'loginInfo' });
            }

            await this.setLocalStorage(response);

            // Default Location
            this.locationservice.getDefaultLocation(response["Data"].Id).subscribe({
              next: (res) => {
                if (res["Data"] != null && res["Success"] === true) {
                  this.storageService.setItem(
                    "Location",
                    JSON.stringify({
                      Id: res["Data"].LocationId,
                      Name: res["Data"].LocationName,
                    })
                  );
                  this.toastrService.scheduleReminders();
                }
                this.getFormat(response["Data"].CompanyId);
                this.getGeneralSetting();
              }
            });

            // Language
            const languageData = response["Data"].LanguageCode ?? 'en';
            this.storageService.setItem("language", languageData);

            // Terms
            const termsData = {
              AgreeTerms: response["Data"].AgreeTerms,
              SkipTermsCount: response["Data"].SkipTermsCount
            };
            this.shared.setTermsInfo(termsData);

            // Feature Access
            this.featureAccessService.setFeature(response["Data"].SubscriptionAccesses);

            if (!this.storageService.getItem('sessionStart')) {
              this.sessionTimer.startSession();
            }

            // WebSocket
            const data = this.authService.getWebScoketData();
            if (data) {
              this.wsService.connect(data.userId, data.companyId);
              this.wsService.onForceLogout((reason) => {
                this.commonComponentService.startLogout(reason);
              });
            }
          }
          else if (response["ResponseCode"] == 499 && response["AccessToken"]) {
            // Onboarding user with pending payment — authenticate and go to Dashboard
            this.shared.setOnboardUserStorage(response);
            this.storageService.setItem("IsOnboardingPaymentPending", "true");
            this.LoaderService.hide();
            this.loadingSubmit = false;
            this.menuHorService.setPath("Dashboard");
            this.route.navigate(["/Dashboard"]);
            return;
          }
          else if (response["ResponseCode"] == 105) {
            // Email/OTP Not Verified
            this.LoaderService.hide();
            this.storageService.setItem("email", userModel.UserName);
            this.route.navigate(["/Redirect"], {
              queryParams: { IsForOTPVerifiedFlow: true }
            });
          }
          else if (errorResponseCodes.includes(response["ResponseCode"])) {
            // Email OTP not verified and T&C not agreed
            this.LoaderService.hide();
            this.shared.showToast(this.translate.instant(messages[response["ResponseCode"]]), "Error");
          }
          else {
            this.LoaderService.hide();
            this.shared.showToast(messages[response["ResponseCode"]], "Error");
          }

          this.loadingSubmit = false;
        })();
      },

      error: (error) => {
        this.LoaderService.hide();
        setTimeout(() => {
          if (!this.storageService.getItem("IA")) {
            this.redirect.getIPAddress().subscribe({
              next: (x: any) => {
                const ipAddress = x.ip;
                this.ipAddress = ipAddress;
                this.storageService.setItem("IA", this.ipAddress);
              }
            });
          }
          if (error.status != 403) {
            this.shared.showToast(error?.error?.Message ?? "Something went wrong, please try again later", "Error");
          }
        }, 200);
        this.route.navigate([""]);
        this.loadingSubmit = false;
      },

      complete: () => {
        // optional: cleanup or logging
      }
    });
  }

  private async setLocalStorage(response: any): Promise<void> {
    if (!response["Data"]["IsFirst"]) {
      this.storageService.setItem("IsFirst", response["Data"]["IsFirst"]);
    }
    this.storageService.setItem("CompanyName", response["Data"].CompanyName);
    this.storageService.setItem("CompanyMobileNumber", response["Data"].CompanyMobileNumber);
    this.storageService.setItem("CompanyEmail", response["Data"].CompanyEmail);
    this.storageService.setItem("token", response["AccessToken"]);
    this.storageService.setItem("Name", response["Data"].Name);
    this.storageService.setItem("userId", response["Data"].Id);
    this.storageService.setItem("companyId", response["Data"].CompanyId);
    this.storageService.setItem("DoctorTypeId", response["Data"].DoctorTypeId);
    this.storageService.setItem("DoctorTypeName", response["Data"].DoctorTypeObj ? response["Data"].DoctorTypeObj.DoctorTypeName : "");
    this.storageService.setItem("UserName", response["Data"].UserName);
    const redirectMenu = response["Data"]?.RedirectMenu;
    this.redirectMenu = redirectMenu && redirectMenu.trim().length > 0 ? redirectMenu : "Dashboard";
    this.isTwoFactorAuth = response["Data"].IsTwoFactorAuth;
    this.storageService.setItem("selectedPlan", response["Data"].selectedPlan ?? "5");
    this.storageService.setItem("AspNetRole", response["Data"].AspNetRoleString);
    this.storageService.setItem("IsTour", response["Data"].IsTour);
    this.storageService.setItem("IsVideoCall", response["Data"].IsVideoCall);
    this.storageService.setItem("IsHomeVisit", response["Data"].IsHomeVisit);
    this.storageService.setItem("IsHospitalVisit", response["Data"].IsHospitalVisit);
    this.storageService.setItem("IsRecoveryVisit", response["Data"].IsRecoveryVisit);
    this.isShowUpgradePopup = response["Data"].isShowUpgradePopup;
    this.storageService.setItem("shouldUpgrade", response["Data"].isShowUpgradePopup);
    this.storageService.setItem("SelectedPlanName", response["Data"].SelectedPlanName);
    this.storageService.setItem("ExpiredDate", response["Data"].expiryDate);
    this.storageService.setItem("isSoonExpire", response["Data"].isSoonExpire);
    this.storageService.setItem("AddOnAmount", response["Data"].AddOnAmount);
    this.storageService.setItem("IsRestrictPatientData", response["Data"].IsRestrictPatientData);
    this.storageService.setItem("RestrictedDate", new Date(response["Data"].RestrictedDate).toISOString());
    this.storageService.setItem("IsAdmin", response["Data"].IsAdmin);

  }

  async getFormat(id: any) {
    await this.shared.getCompanyByIdpromise(id).then((res) => {
      if (res["Success"] === true && res["Data"]["CurrencyObj"]?.hasOwnProperty("CurrencySymbol")) {
        this.storageService.setItem(
          "Currency",
          res["Data"]["CurrencyObj"]["CurrencySymbol"]
        );
        this.storageService.setItem(
          "IsWhatsAppDisplay",
          res["Data"]["IsWhatsAppDisplay"]
        );

        this.menuHorService.setPath(this.redirectMenu);
        this.route.navigate([this.redirectMenu]).then(() => {
          if (this.isShowUpgradePopup) {
            const dialogRef = this.dialog.open(CommonComponentComponent, {
              disableClose: true,
              panelClass: "popup_custom_width_small",
              autoFocus: false,
              width: "70%",
              data: {
                isShowPlanReminder: true,
              },
            });
            dialogRef.afterOpened().subscribe(() => {
              this.translate.use(this.storageService.getItem("language"));
            });
          }
          this.storageService.removeItem("email");
          this.storageService.removeItem("passwordHash");
          this.storageService.removeItem("resendTimer");
          this.storageService.removeItem("otpExpiryTime");
          clearInterval(this.timerInterval);
          clearInterval(this.expiryTimerInterval);
        });
        this.LoaderService.hide();
      }

      else {
        this.LoaderService.hide();
        this.shared.showToast(this.translate.instant("common.errMsg"), "Error");
      }
    });
  }

  async getGeneralSetting() {
    this.shared.getLocalStorageGeneralSetting();
  }

  async loginWithOtp(code: string, patientId: string = null) {
    let ipLocation = this.storageService.getItem("IL") ?? '';
    let ipAddress = this.storageService.getItem("IA") ?? '';
    const deviceInfo = this.deviceDetectorService.getDeviceInfo();
    let deviceType = this.getLoginDeviceType(deviceInfo.deviceType);

    const otpData = {
      Email: this.email,
      Code: code,
      Domain: this.domain,
      ipAddress: ipAddress,
      ipLocation: ipLocation,
      deviceType: deviceType,
      IsTwoFactorAuthenticated: true,
      PatientId: patientId
    };

    this.loadingSubmit = true;
    this.LoaderService.show();

    this.authService.verifyLoginOtp(otpData).pipe(first()).subscribe({
      next: (response: any) => {
        if (response.Success === true &&
          response.Data != null &&
          response.AccessToken != null &&
          response.Data.IsOnboarded && !response.Data.IsOnboardingPaymentPending) {
          this.onBoardingUserResponse(response);
          return;
        }

        if (response["UsersList"] && response["UsersList"].length > 1) {
          this.dialog.open(PatientSelectionComponent, {
            data: { patientList: response["UsersList"], fromLoggedInUser: false },
            disableClose: true,
          }).afterClosed().subscribe((res) => {
            if (res) {
              this.loginWithOtp(code, res.PatientId);
            }
          });
          sessionStorage.setItem("PatientList", JSON.stringify(response["UsersList"]));

          this.loadingSubmit = false;
        } else {
          this.loginResponseHandlerService.handleLoginResponse(response, {
            domain: this.domain,
            isOtpLogin: true,
            isGoogleLogin: false,
            isAdminLogin: false
          }).finally(() => {
            this.LoaderService.hide();
            this.loadingSubmit = false;
          });
        }
      },
      error: (error) => {
        this.LoaderService.hide();
        this.loadingSubmit = false;
        this.shared.showToast(error.error?.Message ?? "Something went wrong", "Error");
      }
    });

  }

  onBoardingUserResponse(response: any) {
    if (response["ResponseCode"] == 105) {
      const companyId = response.Data.Id;
      const email = response.Data.Email;
      this.storageService.setItem("email", email);
      this.route.navigate(["/OTPVerification"], { state: { Data: { Email: email, CompanyId: companyId }, isRegistration: true } });
    } else {
      this.shared.setOnboardUserStorage(response);
      this.LoaderService.hide();
      this.menuHorService.setPath("Dashboard");
      this.route.navigate(["/Dashboard"]);
    }
  }


  sendRegistrationOtp() {
    const companyId = this.TempData.CompanyId;
    const email = this.TempData.Email;
    this.shared.RegisterSendOtp(companyId, email).subscribe({
      next: (response: any) => {
        if (response["Success"]) {
          this.shared.showToast(response.Message ?? "OTP sent successfully", "Success");
          this.startResendTimer(true);
          this.setOtpExpiryTime(true);
        } else {
          this.shared.showToast(response.Message ?? "Failed to send OTP", "Error");
        }
        this.loadingResend = false;
        this.LoaderService.hide();
      },
      error: () => {
        this.shared.showToast("Something went wrong while resending OTP", "Error");
        this.loadingResend = false;
        this.LoaderService.hide();
      }
    });
  }

  verifyRegistrationOtp(code: string) {
    const companyId = this.TempData.CompanyId;
    this.loadingSubmit = true;
    this.shared.RegisterVerifyOtp(companyId, code).subscribe({
      next: (res: any) => {
        if (res.Success) {
          this.shared.showToast(res.Message ?? "Verification successful", "Success");
          this.login();
        } else {
          this.shared.showToast(res.Message ?? "Invalid verification code", "Error");
        }
        this.loadingSubmit = false;
      },
      error: (err) => {
        this.shared.showToast(err.error?.Message ?? "Something went wrong", "Error");
        this.loadingSubmit = false;
      }
    });
  }
  resetCredentialAfterLogin() {
    localStorage.removeItem("passwordHash");
    localStorage.removeItem("email");
  }

  private getLoginDeviceType(_deviceType: string): string {
    const platform = Capacitor.getPlatform();
    if (platform === "android") {
      return "Android";
    }
    if (platform === "ios") {
      return "Ios";
    }
    const isPwa = window.matchMedia?.("(display-mode: standalone)").matches || (window.navigator as any).standalone === true;
    if (isPwa) {
      return "PWA";
    }
    return "Web";
  }
}
